import React, { Fragment } from 'react';
import { dayJSLocaleMap } from '../../../../utils/dayjs';
import Text from '../../../text';
import dayjs from '../day';
const DateCalendarTitle = ({ lang, target, onChangeMode }) => {
    const formatedLabels = dayjs(lang, target) // ensure latest locales
        .format(dayJSLocaleMap[lang].formats.PICKER_HEADER)
        .split(',');
    return (React.createElement(React.Fragment, null, formatedLabels.map((formatedLabel, i) => {
        const mode = formatedLabel.includes('MONTH_')
            ? 'MONTH'
            : 'YEAR';
        const label = formatedLabel.split(`${mode}_`).join('');
        return (React.createElement(Fragment, { key: formatedLabel },
            React.createElement(Text, { lang: lang, fontType: "Subheading", onClick: () => onChangeMode(mode) }, label),
            i === 0 && React.createElement(React.Fragment, null, "\u00A0")));
    })));
};
export default DateCalendarTitle;
//# sourceMappingURL=DateCalendarTitle.js.map